import { Thumbs, Controller, Keyboard } from 'swiper/modules';
import { Swiper } from 'swiper';

export class ProductImagesMain {
	static sliders = [];

	private element: HTMLElement;
	private readonly sliderElement: HTMLElement;
	private readonly thumbs: Swiper;
	private sliderSettings = () => ({
		modules: [Thumbs, Controller, Keyboard],
		slidesPerView: 1,
		thumbs: {
			swiper: this.thumbs,
		},
		keyboard: {
			enabled: Boolean(this.element.closest('.product-images-modal')),
			onlyInViewport: true,
		},
		on: {
			init: (swiper) => {
				if (swiper.slides[0].classList.contains('product-images-main__slide--video')) swiper.slideTo(1, 0);
			},
		}
	});
	public slider: Swiper;

	constructor(element, thumbs) {
		if (!element) return;
		this.element = element;
		this.thumbs = thumbs;
		this.sliderElement = this.element.querySelector('.product-images-main__slider');

		this.init();
	}

	public init = ():void => {
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
		ProductImagesMain.sliders.forEach((slider) => this.slider.controller.control = slider);
		ProductImagesMain.sliders.forEach((slider) => slider.controller.control = this.slider);
		ProductImagesMain.sliders.push(this.slider);
	};
}
